import newDateWrapper from "../new-date-wrapper/index"

export default function getDifferenceInDays({ startDate, endDate, isAbsoluteDifference = true }) {
  const firstDate = newDateWrapper(startDate)
  const secondDate = newDateWrapper(endDate)
  let timeDifference;
  if (isAbsoluteDifference) timeDifference = Math.abs(secondDate.getTime() - firstDate.getTime());
  else timeDifference = secondDate.getTime() - firstDate.getTime()

  const dayMilliseconds = 1000 * 3600 * 24;
  return Math.round(timeDifference / dayMilliseconds);
}
